import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { altDateFormat } from 'utils/date';

import { LocaleContext } from 'context/LocaleContext';
import BodyPortal from 'portals/body-portal';

import LocalizedDatePicker from 'components/LocalizedDatePicker';

import IconArrowDown from 'icons/icon-arrow-down';

const DatePickerInput = ({ value, placeholder, onClick }) => <button className="btn btn-input wide" onClick={onClick}>{value || placeholder} <IconArrowDown /></button>;

const EndSelector = ({ value, onChange }) => {
    const locale = useContext(LocaleContext);
    const { t } = useTranslation(['recurring', 'common']);

    return (
        <div className="resource-repeat-row">
            <div className="row-label">
                { t('Ends (date)') }
            </div>

            <div className="row-value">
                <div className="row-input">
                    <LocalizedDatePicker
                        selected={value}
                        showTimeSelect={true}
                        minDate={new Date()}
                        dateFormat={altDateFormat(locale.dateTimeFormats.fullDateTime)}
                        placeholderText={ t('common:never') }
                        customInput={<DatePickerInput />}
                        popperContainer={BodyPortal}
                        onChange={onChange}
                    />
                </div>
            </div>
        </div>
    )
}

export default EndSelector;
